module.exports = __webpack_public_path__ + "img/3-twoImg.267f26a0.png";